module.exports = __webpack_public_path__ + "img/fm.e59fd040.svg";